// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
* @author mfranco (mfranco@mobinteg.com)
* @author mbarbosa (mbarbosa@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import DebtPhaseContracts from "../../components/DebtPhaseContracts"
import DebtPhaseDocuments from "../../components/DebtPhaseDocuments"
import DebtPhaseExpenses from "../../components/DebtPhaseExpenses"
import LitigationDetails from "../../components/LitigationDetails"
import SaveButton from "../../components/SaveButton"
import { connect } from "react-redux"
import { getLitigationById } from "../../actions"
import * as strings from "../../strings"
import { toastr } from "react-redux-toastr"
import DebtSummaryHeader from "../../components/DebtSummaryHeader"
import DebtPhaseOptions from "../../components/DebtPhaseOptions"
import _ from "lodash"
import {
  newContact,
  updateContactHistory,
  updateDebtorContact,
  getDebtById,
  updateLitigation,
} from "../../actions"
import {
  cleanupOption,
} from "../../utils"


class LitigationView extends Component {
  props: {
    debt: any,
    getDebtById: any,
    newContact: any,
    updateContactHistory: any,
    updateDebtorContact: any,
    addDebtor: any,
    suggestions: any,
    auth: {
      token: string,
    },
    match: {
      path: string,
      params: {
        litigationId: string,
      },
    },

    mainContactId: number,
    contacts: any,
  }

  state = {
    request: {
      litigation: undefined,
    },
    litigation: undefined,
  }

  calculateCapitalValue = ( contracts ) => {
    const invoices = _.flattenDeep( contracts.map( contract => contract.invoices ) )
    const capitalValue = _.round( _.sum( invoices.map( invoice => parseFloat( invoice.value ) ) ), 2 )
    return capitalValue
  }

  fetchLitigation = litigationId => getLitigationById( this.props.auth.token, litigationId )
    .then( response => {
      let litigation = ( response.message !== "OK" ) ? null : response.result
      if ( !litigation.litigationCapitalValue ) {
        const litigationCapitalValue = this.calculateCapitalValue( litigation.contracts )
        litigation = {
          ...litigation,
          litigationCapitalValue,
        }
      }
      return this.setState( {
        request: {
          ...this.state.request,
          litigation,
        },
        litigation,
      } )
    } )

  componentWillMount = () => {
    const litigationId = parseInt( this.props.match.params.litigationId, 10 )
    this.fetchLitigation( litigationId )
      .then( () => {
        this.props.getDebtById( this.state.litigation.idDebt )
      } )

  }

  renderDetails = () => (
    <LitigationDetails
      token={this.props.auth.token}
      suggestions={this.props.suggestions}
      litigation={this.state.litigation}
      onChange={newDetails => this.setState( {
        litigation: {
          ...this.state.litigation,
          ...newDetails,
        },
      } ) }
    />
  )

  renderContracts = litigation => {
    const processId = { idLitigation: litigation.id }
    return (
      <DebtPhaseContracts
        processId={processId}
        contracts={litigation.contracts}
        resetFunc={this.fetchLitigation} />
    )
  }

  renderDocuments = litigation => {
    return (
      <DebtPhaseDocuments
        documents={litigation.documents}
        onChange={newDocuments => this.updateLitigationAndRequest( {
          documents: newDocuments,
        } ) }
        debt={this.props.debt}
        phaseId={litigation.id}
        fileDownloadCommand="getLitigationDocument"

        fileRemoveCommand="removeLitigationDocument"
        fileUploadCommand="newLitigationDocuments"
        fileUploadArgs={{
          id: litigation.id,
        }}
      />
    )
  }

  updateLitigationAndRequest = newData => {
    const newLitigation = {
      ...this.state.litigation,
      ...newData,
    }

    this.setState( {
      request: {
        ...this.state.request,
        litigation: newLitigation,
      },
      litigation: newLitigation,
    } )
  }


  save = () => {
    const { litigation } = this.state
    const preparedLitigation = _.omit( litigation, [
      "bniNumber", "contracts", "debt", "otherExpenses", "documents",
      "idDebt", "idExecution", "idLot", "sequenceNumber",
      "totalValue", "capitalValue", "litigationExecutions",
      "position", "expenses",
    ] )

    const litigationFormatted = {
      ...preparedLitigation,
      interest: litigation.interest ? parseFloat( litigation.interest ) : null,
      interestRate: litigation.interestRate ? parseFloat( litigation.interestRate ) : null,
      litigationCapitalValue: litigation.litigationCapitalValue ?
        parseFloat( litigation.litigationCapitalValue ) : null,
      justiceTax: litigation.justiceTax ? parseFloat( litigation.justiceTax ) : null,
      idToExecution: litigation.activeOption.idToExecution,
      activeOption: cleanupOption( litigation.activeOption, [ "idToExecution", "validFrom" ] ),
      recoveredValue: litigation.recoveredValue ? parseFloat( litigation.recoveredValue ) : null,
    }

    this.updateLitigationAndRequest( litigationFormatted )
    updateLitigation( this.props.auth.token, litigationFormatted )
      .then( () => toastr.success( strings.generalStrings.changesSaved ) )
      .catch( () => toastr.error( strings.generalStrings.errorSaving ) )

  }

  reset = () => this.setState( {
    litigation: this.state.request.litigation,
  } )

  render () {
    const { litigation } = this.state

    // TODO: Some kind of loading animation
    if ( litigation === undefined ) {
      return <div />
    }

    if ( litigation === null || this.props.debt.length === 0 ) {
      return (
        <div>
          {strings.generalStrings.errorFound}
        </div>
      )
    }

    return (
      <div>
        <DebtSummaryHeader
          debtPhaseEnum="Litigation"
          title={strings.generalStrings.debt}
          debt={this.props.debt}
          manager={this.state.litigation.manager}
          managers={this.state.request.litigation.availableManagers}
          isProcessPhase={true}
          executionId={litigation.idExecution}
          lotId={litigation.idLot}
          onChange={( managerId ) => this.setState( {
            litigation: {
              ...this.state.litigation,
              manager:{id:managerId}
            },
          } ) }/>
        <DebtPhaseOptions
          debtPhaseEnum="Litigation"
          debtPhase={litigation}
          debt={this.props.debt}
          debtPhaseId={parseInt( this.props.match.params.litigationId, 10 )}
          onChange={( newDetails, litigationDetails ) => this.setState( {
            litigation: {
              ...this.state.litigation,
              ...litigationDetails,
              activeOption: {
                ...this.state.litigation.activeOption,
                ...newDetails,
              },
            },
          } ) }
          parentOption={this.state.litigation.activeOption}/>
        {this.renderDetails()}
        {this.renderContracts( litigation )}
        <DebtPhaseExpenses
          expenses={this.state.litigation.expenses}
          onChange={ expenses => this.updateLitigationAndRequest( {
            expenses,
          } ) }
          idLitigation={litigation.id}
        />
        {this.renderDocuments( litigation )}
        <SaveButton
          onSave={this.save}
          onCancel={this.reset}
          show={
            !_.isEqual( this.state.request.litigation, this.state.litigation )
          }
        />
      </div>
    )
  }
}

export default connect( store => (
  { auth: store.auth, debt: store.getDebt, suggestions: store.suggestions } ),
{ newContact, updateContactHistory, updateDebtorContact, getDebtById }
)( LitigationView )



// WEBPACK FOOTER //
// ./src/views/LitigationView/index.jsx